import { Injectable } from '@angular/core';

import { AdSpaceApplicationStatus } from 'src/app/shared/constants/adSpace';

@Injectable({
  providedIn: 'root',
})
export class AssetService {
  url(name: string) {
    return `assets/icons/${name}.svg`;
  }

  adSpaceApplicationStatusIcon(status) {
    switch (status) {
      case AdSpaceApplicationStatus.ACCEPTED: {
        return this.url('accepted');
      }

      case AdSpaceApplicationStatus.PENDING: {
        return this.url('pending');
      }

      case AdSpaceApplicationStatus.REJECTED: {
        return this.url('rejected');
      }
    }

    return null;
  }

  getFlag(code: string) {
    return `https://flags.viperdev.io/png25px/${code.toLowerCase()}.png`;
  }
}
